import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Caracteristica, TipoCaracteristica } from '../../../../interfaces/caracteristica';
import { FormControl, Validators } from '@angular/forms';
import { CaracteristicaService } from '../../../../providers/caracteristica.service';
import { MatSelectionList, MatSelectChange } from '@angular/material'; import { CaracteristicaValor } from '../../../../interfaces/valor-caracteristica';
    

@Component({
  selector: 'app-caracteristica',
  templateUrl: './caracteristica.component.html',
  styleUrls: ['./caracteristica.component.scss']
})
export class CaracteristicaComponent implements OnInit {
  @Input() IdCaracteristica?: number | string;
  caracteristica: Caracteristica;
  caracteristicaTipos: TipoCaracteristica[] = <TipoCaracteristica[]>[];
  cargandoTipos: boolean = false;
  @Output() onCaracteristicaInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  @ViewChild('opciones') opciones: MatSelectionList;

  descripcionFormControl = new FormControl('', [
    Validators.required
  ]);
  tipoCaracteristicaFormControl = new FormControl('', [
    Validators.required
  ]);
  opcionFormControl = new FormControl('', []);

  constructor(
    private caracteristicaService: CaracteristicaService
  ) { }

  ngOnInit() {
    this.caracteristica = new Caracteristica();

    if (this.IdCaracteristica != null) { // si recibo un id solicitar los datos 
      // Este campo no es editable
      this.tipoCaracteristicaFormControl.disable();

      this.formState.emit({ cargando: true });
      this.caracteristicaService.getCaracteristicas(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdCaracteristica: this.IdCaracteristica
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data) {
            if (respuesta.data[0]) {
              var caracteristica = respuesta.data[0];
              this.caracteristica = new Caracteristica(
                caracteristica.IdCaracteristica,
                caracteristica.descripcion,
                Object.assign([], caracteristica.valores),
                null,
                new TipoCaracteristica(
                  caracteristica.tipoCaracteristica.id,
                  caracteristica.tipoCaracteristica.descripcion
                ),
                !!+caracteristica.mostrarDescripcion
              );

              this.tipoCaracteristicaFormControl.setValue(this.caracteristica.tipoCaracteristica);

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }

    this.traerTiposCaracteristica();
  }

  traerTiposCaracteristica(): void {
    this.caracteristicaTipos = <TipoCaracteristica[]>[];
    this.cargandoTipos = true;
    this.caracteristicaService.getTiposCaracteristica(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        generico: ''
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data) {
          if (respuesta.data.tipoCaracteristicas) {
            respuesta.data.tipoCaracteristicas.forEach((tipoCaracteristica: any) => {
              this.caracteristicaTipos.push(new TipoCaracteristica(
                tipoCaracteristica.IdTipoCaracProd,
                tipoCaracteristica.TipoCaracProdDesc
              ));
            });
          }
        } else {
          this.formState.emit({ // error al buscar datos
            estado: 3,
            mensaje: 'El dato no podrá ser asignado'
          });
        }

        this.cargandoTipos = false;
      },
      error => {
        this.cargandoTipos = false;

        this.formState.emit({ // error al buscar datos
          estado: 2,
          mensaje: error
        });
      }
    );
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onCaracteristicaInput.emit();
  }

  onTipoCaracteristicaChange(event: MatSelectChange): void {
    var tipoCaracteristica = <TipoCaracteristica>event.value;
    if (tipoCaracteristica.descripcion == "VERDADERO/FALSO") {
      this.caracteristica.valores = <CaracteristicaValor[]>[
        <CaracteristicaValor>{
          descripcion: "SI"
        },
        <CaracteristicaValor>{
          descripcion: "NO"
        },
        <CaracteristicaValor>{
          descripcion: "INDETERMINADO"
        }
      ]
    } else {
      this.caracteristica.valores = <CaracteristicaValor[]>[];
    }
  }

  compararTipoCaracteristica(tipo1: any, tipo2: any): boolean | null { // le dice al select como comparar
    if (tipo1 && tipo2) {
      return tipo1.IdTipoCaracteristica == tipo2.IdTipoCaracteristica;
    }

    return false;
  }

  getCaracteristica(): Caracteristica {
    // revisar las validaciones
    if (this.descripcionFormControl.hasError('required') ||
      this.tipoCaracteristicaFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.descripcionFormControl.markAsTouched();
      this.tipoCaracteristicaFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.caracteristica;
  }

}
